var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 512 512" }, props),
    React.createElement("rect", { width: "512", height: "100", rx: "50", ry: "50" }),
    React.createElement("rect", { y: "206", width: "512", height: "100", rx: "50", ry: "50" }),
    React.createElement("rect", { y: "412", width: "512", height: "100", rx: "50", ry: "50" })
  );
});